export default __webpack_public_path__ + "static/media/PortfolioProject7.81fbddca.png";